import { Controller } from 'react-hook-form';
import { InputSwitch } from 'primereact/inputswitch';

export default function BroadcastToggleField({ control, setValue }) {
  return (
    <Controller
      name="broadcast"
      control={control}
      render={({ field }) => (
        <div className="field flex align-items-center gap-2 mb-3">
          <InputSwitch
            inputId={field.name}
            checked={field.value}
            onChange={(e) => {
              field.onChange(e.value);
              if (!e.value) setValue('channels', ['telegram']);
            }}
          />
          <label htmlFor={field.name} className="m-0">
            Broadcast — one-way alerts only, subscribers can&apos;t message the group
          </label>
        </div>
      )}
    />
  );
}
